// extracted by mini-css-extract-plugin
export default {"empty-state":"empty-state_empty-state__3LhJx","dot-background":"empty-state_dot-background__Cw2gz","content":"empty-state_content__gHrNZ"};